/**
 * Show at most two package cards, preferring titles that look like
 * "Monthly" and "Individual" when present in Firestore data.
 */
export function pickTwoPackages(packages) {
  if (!Array.isArray(packages) || packages.length === 0) return [];

  const title = (p) => (p.title || '').toLowerCase();
  const monthly = packages.find((p) => title(p).includes('monthly'));
  const individual = packages.find((p) => title(p).includes('individual'));

  const out = [];
  if (monthly) out.push(monthly);
  if (individual && individual !== monthly) out.push(individual);
  for (const p of packages) {
    if (out.length >= 2) break;
    if (!out.includes(p)) out.push(p);
  }
  return out.slice(0, 2);
}
